import Vue from 'vue';
import 'styles/pages/guides/index.scss';
import '~scripts/main';

// Core
import { BREAKPOINTS } from '~scripts/core/breakpoints';

// Blocks
import Header from '~scripts/blocks/header';
import Navigation from '~scripts/blocks/navigation';
import initRequestForm from '~scripts/blocks/request-form';

// Components
import '~scripts/components/modals';
import { scrollAnimationProgress } from '~scripts/core/animations';
import SubscribeForm from '~scripts/components/vue/forms/SubscribeForm.vue';

// Breakpoints
const mediaSm = window.matchMedia(`(max-width: ${BREAKPOINTS.smMax})`);

//
// HEADER
//
Header();

//
// NAVIGATION
//
Navigation();

//
// GUIDES CARDS
//
// Animation
let stopGuidesCardsAnimation = [];

const handleGuidesCardsAnimation = () => {
  const guidesCards = document.querySelectorAll('.js-guide-card');

  if (mediaSm.matches) {
    stopGuidesCardsAnimation.forEach((stop) => stop());
  } else {
    stopGuidesCardsAnimation = Array.from(guidesCards, (guideCard) => {
      return scrollAnimationProgress(guideCard, {
        getStart(el) {
          const rect = el.getBoundingClientRect();
          return rect.top + window.scrollY - window.innerHeight;
        },
        getEnd(el, start) {
          return start + 100;
        },
      });
    });
  }
};

handleGuidesCardsAnimation();
mediaSm.addEventListener('change', handleGuidesCardsAnimation);

// Hovering
const guidesCards = document.querySelectorAll('.js-guide-card:not(.guide-card--about)');

guidesCards.forEach((guideCard) => {
  guideCard.addEventListener('mousemove', function (e) {
    const card = this;
    const cardLeft = card.getBoundingClientRect().left;
    const cardWidth = card.offsetWidth;
    const pageX = e.pageX;
    const moveX = Math.abs(Math.round(((pageX - cardLeft) / cardWidth) * 100)) - 50;

    card.style.setProperty('--move', `${moveX}deg`);
  });

  guideCard.addEventListener('mouseleave', function () {
    this.style.removeProperty('--move');
  });
});

//
// DEMO REQUEST FORM
//
const demoRequestForms = document.querySelectorAll('.js-demo-request-form');

demoRequestForms.forEach((form) => {
  initRequestForm(form);
});

//
// SUBSCRIBE FORM
//
const formWrapper = document.querySelector('.js-form-wrapper');

new Vue({
  el: formWrapper,
  components: {
    SubscribeForm: SubscribeForm,
  },
});
